<template>
  <pop-up-layout 
    :title="localization.editar"
    :aceptar="localization.guardar"
    :saving="waitingForLoad"
    :loading="loading"
    :disabled="!cambiado"
    @aceptar="guardar()"
    @volver="$parent.hide()"
  >
    <v-row justify="center" align="center">
      <v-col cols="12">
        <v-form v-model="valid" id="valid" ref="form">
          <o-big-title justify="start"><slot name="title">{{localization.datos}} </slot></o-big-title>
          <v-col>
            <v-row wrap> 
              <v-col cols="12" md="4" lg="4" class="pl-3 pr-3">
                <v-menu
                  v-model="menu"
                  id="menu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="visitDateFormated"
                      id="visitDateFormated"
                      :label="localization.fecha"
                      prepend-icon="event"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="fechaFormat" id="fechaFormat" @input="menu = false" locale="es"></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" md="4" lg="4" class="pl-3 pr-3">
                <v-autocomplete
                  v-model="newVisita.tipoVisita"
                  id="tipoVisita"
                  :no-data-text="$t('sinDatos')"
                  :items="tiposVisitaFiltrados"
                  :item-text="item => `${ item.translates && item.translates[usuario.idioma] !== undefined && item.translates[usuario.idioma] !== null ? item.translates[usuario.idioma] : ''  }`"
                  item-value="name"
                  :label="localization.tipo"
                  :rules="[rules.obligatorio]"
                />
              </v-col>
              <v-col cols="12" md="4" lg="4" class="pl-3 pr-3">
                <v-text-field v-model="newVisita.reportadoPor" id="reportadoPor" :label="localization.reportadoPor"></v-text-field>
              </v-col>
            </v-row>

          

            <!-- Nuevos campos 294972 -->
            <v-row wrap no-gutters> 
              <v-col cols="12" md="4" lg="4" class="pl-3 pr-3" v-if="getConfiguracion.PV_VISITA_FECHA_ALTA_CLIENTE">
                <v-menu
                  v-model="menuAltaCliente"
                  id="menuAltaCliente"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="visitDateAltaClienteFormated"
                      id="visitDateAltaClienteFormated"
                      :label="localization.altaInquilino"
                      prepend-icon="event"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="fechaAltaClienteFormat" id="fechaAltaClienteFormat" @input="menuAltaCliente = false" locale="es"></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" md="4" lg="4" class="pl-3 pr-3" maxlength = "15" v-if="getConfiguracion.PV_VISITA_REGISTRO_ENTRADA">
                <v-text-field 
                  v-model="newVisita.numRegistro"
                  id="numRegistro"
                  :label="localization.registroEntrada"
                  maxlength = "15"
                />
              </v-col>
            </v-row>

            
          </v-col>
          <o-big-title justify="start"><slot name="title">{{localization.contacto}}</slot></o-big-title>
          <v-col>
            <v-row wrap>
              <v-col cols="12" md="4" lg="4" class="pl-3 pr-3">
                <v-text-field
                  v-model="newVisita.nombreContacto"
                  id="nombreContacto"
                  :label="localization.nombre"
                  :rules="[rules.max(60)]"
                />
              </v-col>
              <v-col cols="12" md="4" lg="4" class="pl-3 pr-3">
                <v-text-field
                  v-model="newVisita.telefonoContacto"
                  id="telefonoContacto"
                  :label="localization.telefono"
                  :rules="[rules.phoneNumber]"
                />
              </v-col>
              <v-col cols="12" md="4" lg="4" class="pl-3 pr-3">
                <v-text-field
                  v-model="newVisita.movilContacto"
                  id="movilContacto"
                  :label="localization.movil"
                  :rules="[rules.phoneNumber]"
                />
              </v-col>
            </v-row>
            <v-row wrap>
              <v-col cols="12" md="6" lg="6" class="pl-3 pr-3">
                <v-text-field
                  v-model="newVisita.emailContacto"
                  id="emailContacto"
                  :label="localization.email"
                  :rules="[rules.email]"
                />
              </v-col>
              <v-col cols="12" md="6" lg="6" class="pl-3 pr-3">
                <v-textarea
                  v-model="newVisita.observacionesContacto"
                  id="observacionesContacto"
                  rows="2"
                  maxlength = "100"
                  :label="localization.observaciones"
                />
              </v-col>
            </v-row>
          </v-col>
        </v-form>
      </v-col>
    </v-row>
  </pop-up-layout>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import moment from 'moment'
import rulesMixin from '@/components/generic/rules.js'

export default {
  mixins: [rulesMixin],
  props: {
    visita: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      waitingForLoad: false,
      loading: false,
      newVisita: null,
      cambiado: false,
      valid: true,
      menu: false,
      menuAltaCliente: false,
      fechaFormat: null,
      fechaAltaClienteFormat: null,
      tiposVisitaFiltrados: []
    }
  },
  async created () {
    try {
      this.loading = true
      this.newVisita = Object.assign({}, this.visita)
      this.fechaFormat = (this.newVisita.fecha) ? moment(this.newVisita.fecha, 'DD-MM-YYYY').format('YYYY-MM-DD') : ''
      this.fechaAltaClienteFormat = (this.newVisita.fechaAltaCliente) ? moment(this.newVisita.fechaAltaCliente, 'DD-MM-YYYY').format('YYYY-MM-DD') : ''
      await this.getVisitTypes()
      await this.loadConfiguracion()
      await this.getPropertiesByStringAndPropertyDevId(this.visita.promocionId)
      await this.getInmueblesEspecialesByStringAndIdPromocion(this.visita.promocionId)
      await this.getTiposVisitaPorAmbito()
      this.loading = false
    } catch (error) {
      this.addAlert({ texto: this.$t('errorAlGenerarEditor') + error, color: 'error' })
    }
  },
  computed: {
    ...mapGetters({
      getConfiguracion: 'configuracion/getConfiguracion'
    }),
        translates() {
      if (this.$store.state.incidencias.translates) {
        return this.$store.state.incidencias.translates;
      }
      return [];
    },
    usuario() {
      return JSON.parse(localStorage.getItem('usuario'))
    },
    visitTypes () {
      if (this.$store.state.incidencias.tipoVisita) {
        return this.$store.state.incidencias.tipoVisita
      }
      return []
    },
    visitDateFormated () {
      return (this.fechaFormat) ? moment(this.fechaFormat, 'YYYY-MM-DD').format('DD/MM/YYYY') : ''
    },
    visitDateAltaClienteFormated () {
      return (this.fechaAltaClienteFormat) ? moment(this.fechaAltaClienteFormat, 'YYYY-MM-DD').format('DD/MM/YYYY') : ''
    },
    inmueblesPorPromo () {
      if (this.$store.state.incidencias.propertiesByStringAndPropDevId) {
        return this.$store.state.incidencias.propertiesByStringAndPropDevId
      }
      return []
    },
    inmueblesEspecialesPorPromo () {
      if (this.$store.state.incidencias.inmueblesEspecialesByStringAndIdPromocion) {
        return this.$store.state.incidencias.inmueblesEspecialesByStringAndIdPromocion
      }
      return []
    },
    localization () {
      return this.$t('popUpEditarVisita')
    }
  },
  methods: {
    ...mapActions({
      addAlert: 'alerts/add',
      getVisitTypes: 'incidencias/getVisitTypes',
      updateVisit: 'incidencias/updateVisit',
      loadConfiguracion: 'configuracion/obtenerConfiguracion',
      getPropertiesByStringAndPropertyDevId: 'incidencias/getPropertiesByStringAndPropertyDevId',
      getInmueblesEspecialesByStringAndIdPromocion: 'incidencias/getInmueblesEspecialesByStringAndIdPromocion'
    }),
    async guardar () {
      this.$refs.form.validate()
      if (!this.valid) {
        this.addAlert({texto: this.$t("revisarCamposRojo"), color: 'error'})
      } else {
        this.waitingForLoad = true
        try {
          let obj = {
            id: this.newVisita.idVisita,
            referencia: this.newVisita.visitaReferencia,
            reportadoPor: this.newVisita.reportadoPor,
            nombreContacto: this.newVisita.nombreContacto,
            telefonoContacto: this.newVisita.telefonoContacto,
            movilContacto: this.newVisita.movilContacto,
            emailContacto: this.newVisita.emailContacto,
            observacionesContacto: this.newVisita.observacionesContacto,
            fecha: this.fechaFormat,
            clientDate: this.fechaAltaClienteFormat,
            tipoVisita: this.getTipoVisita(),
            entryRegister: this.newVisita.numRegistro
          }
          await this.updateVisit(obj)
          this.$emit('recargar')
          this.$parent.hide()
        } catch (error) {
          this.addAlert({ texto: this.$t('errorModificarVisita') + error, color: 'error' })
        }
        this.waitingForLoad = false
      }
    },
    getTiposVisitaPorAmbito () {
      let inmueble = this.inmueblesPorPromo.find(x => x.inmuebleId === this.visita.inmuebleId)
      if (!inmueble) {
        inmueble = this.inmueblesPorPromo.find(x => x.inmuebleEspecialId === this.visita.inmuebleId)
        if (!inmueble) {
          inmueble = this.inmueblesEspecialesPorPromo.find(x => x.inmuebleEspecialId === this.visita.inmuebleId)
        }
      }
      let ambito = false
      if ( inmueble ) {
        ambito = inmueble.ambito
      }
      
      if (ambito === '1') {
        this.tiposVisitaFiltrados = []
        this.getConfiguracion.tiposIncidenciaVenta.forEach(x => {
          let tipo = this.visitTypes.find(j => j.code === x)
          this.tiposVisitaFiltrados.push(tipo)
        })
      } else if (ambito === '2') {
        this.tiposVisitaFiltrados = []
        this.getConfiguracion.tiposIncidenciaAlquiler.forEach(x => {
          let tipo = this.visitTypes.find(j => j.code === x)
          this.tiposVisitaFiltrados.push(tipo)
        })
      } else {
        this.tiposVisitaFiltrados = []
        this.getConfiguracion.tiposIncidenciaSinOperacion.forEach(x => {
          let tipo = this.visitTypes.find(j => j.code === x)
          this.tiposVisitaFiltrados.push(tipo)
        })
      }
      
      return this.tiposVisitaFiltrados
    },
    getTipoVisita () {
      return this.visitTypes.find(x => x.name === this.newVisita.tipoVisita).id
    }
  },
  watch: {
    newVisita: {
      deep: true,
      handler () {
        this.cambiado = true
      }
    }
  }
}
</script>